var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_2",
    "data-name": "Component 37 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 27,
    height: 27,
    rx: 5,
    fill: "#333",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icons_trash.fill",
    "data-name": "Icons=trash.fill",
    d: "M5.606,15.721h6.672a1.4,1.4,0,0,0,1.555-1.46l.447-10.182h.981a.618.618,0,1,0,0-1.237H2.623a.618.618,0,1,0,0,1.237H3.61l.447,10.182A1.4,1.4,0,0,0,5.606,15.721Zm1.082-2.145a.452.452,0,0,1-.481-.461L5.991,5.62a.44.44,0,0,1,.483-.463.457.457,0,0,1,.486.456l.21,7.5A.44.44,0,0,1,6.688,13.576Zm2.257,0a.457.457,0,0,1-.5-.46v-7.5a.458.458,0,0,1,.5-.461.453.453,0,0,1,.491.461v7.5A.452.452,0,0,1,8.945,13.576Zm2.25,0a.44.44,0,0,1-.481-.465l.21-7.492a.458.458,0,0,1,.486-.462.443.443,0,0,1,.483.463l-.216,7.495A.454.454,0,0,1,11.195,13.576ZM5.671,3.092h1.45V1.851a.517.517,0,0,1,.572-.529h2.491a.517.517,0,0,1,.572.529V3.092H12.2V1.786A1.711,1.711,0,0,0,10.271,0H7.6a1.711,1.711,0,0,0-1.93,1.786Z",
    transform: "translate(4.834 5.68)",
    fill: "#f53c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete-icon.cd04fdf8ba86880b915b314e91485d36.svg";
export { ForwardRef as ReactComponent };